import { render } from "./B2bTableMenuAuditoriaDocumentos.vue?vue&type=template&id=209a4aaa&scoped=true&lang=pug"
import script from "./B2bTableMenuAuditoriaDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuAuditoriaDocumentos.vue?vue&type=script&lang=js"

import "./B2bTableMenuAuditoriaDocumentos.vue?vue&type=style&index=0&id=209a4aaa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209a4aaa"]])

export default __exports__